import {
  BadRequestError,
  ConflictError,
  ForbiddenError,
  NotFoundError,
  ServiceUnavailableError,
  TooManyRequestsError,
  UnauthorizedError,
} from '@/types/errors';

import { RPCError } from './models';

function getRPCErrorMessage(error: RPCError): string {
  const data = Array.isArray(error.data) ? error.data[0] : error.data;
  return data?.reason ?? data?.data?.reason ?? error.message;
}

export function RPCErrorResolver(error: RPCError): never {
  const options: ErrorOptions = { cause: error };
  switch (error.code) {
    case -32_001: {
      throw new UnauthorizedError(error.message, options);
    }
    case -32_002: {
      throw new ForbiddenError(error.message, options);
    }
    case -32_003: {
      throw new NotFoundError(error.message, options);
    }
    case -32_004: {
      throw new ConflictError(error.message, options);
    }
    case -32_005: {
      throw new TooManyRequestsError(error.message, options);
    }
    case -32_600: {
      throw new BadRequestError(getRPCErrorMessage(error), options);
    }
    case -32_603: {
      throw new ServiceUnavailableError(getRPCErrorMessage(error), options);
    }
    default: {
      throw new ServiceUnavailableError(getRPCErrorMessage(error), options);
    }
  }
}
